<template>
  <div class="serviceheader">
    <div class="hxq_subpage">
      <div class="zmpp_con w1200">
        <div class="imui-center">
          <lemon-imui
            :user="user"
            ref="IMUI"
            width="100%"
            height="750px"
            :contextmenu="contextmenu"
            :contact-contextmenu="contactContextmenu"
            :theme="theme"
            :hide-menu="hideMenu"
            :hide-menu-avatar="hideMenuAvatar"
            :hide-message-name="hideMessageName"
            :hide-message-time="hideMessageTime"
            @change-menu="handleChangeMenu"
            @change-contact="handleChangeContact"
            @pull-messages="handlePullMessages"
            @message-click="handleMessageClick"
            @menu-avatar-click="handleMenuAvatarClick"
            @send="handleSend"
          >
            <template #sidebar-message-fixedtop>
              <div class="search-bar">
                <input class="search-bar-input" placeholder="搜索最近联系人" v-model="SearchValue" @input="SearchContacts(SearchValue)">
              </div>
            </template>
            <template #cover>
              <div class="cover">
                <img src="../../assets/images/zpj_06.png">
              </div>
            </template>
            <template #message-side>
              <div class="slot-group">
                <div class="nmzp-right-pane">
                  <div class="nmzp-right-tabs">
                    <div class="nmzp-tabs clearfix">
                      <div style="width: 50%;" class="nmzp-tab ellipsis" :class="{active:showinfo == 'product-info'}" @click="showproductinfo('product-info')">正在咨询</div>
                      <div style="width: 50%;" class="nmzp-tab ellipsis" :class="{active:showinfo == 'orders-box'}" @click="showproductinfo('orders-box')">我的订单</div>
                    </div>
                  </div>
                  <div class="nmzp-right-content" style="height: 647px;">
                    <div v-if="showinfo == 'product-info'" class="product-info">
                      <div class="product-info-tabs">
                        <div class="nmzp-underline-tabs clearfix">
                          <div class="nmzp-underline-tab ellipsis" style="width: 100%;">
                            <div class="nmzp-underline-tab-content active">最近浏览</div>
                          </div>
                        </div>
                        <div class="recent-block" style="height: 565px;">
                          <div class="recent-block-inner" style="padding-right: 10px;">
                            <div v-for="(item,index) in Historylist" :key="index" class="recent-item clearfix">
                              <div class="img-box">
                                <router-link :to="{path:'/GoodsDetail',query:{id:item.goods_id}}" target="_blank" :title="item.title">
                                  <img v-real-img="item.imgpath" width="60" height="60" :alt="item.title" src="../../assets/images/zwtp.jpg">
                                </router-link>
                              </div>
                              <div class="recent-item-details">
                                <router-link :to="{path:'/GoodsDetail',query:{id:item.goods_id}}" target="_blank" :title="item.title">
                                  <h4 class="recent-item-title ellipsis2-for-webkit" :title="item.title">{{ item.title }}</h4>
                                </router-link>
                                <p class="recent-item-price" v-if="item.tax_price > 0">¥{{ item.tax_price }}</p>
                                <p class="recent-item-price" v-else>询价</p>
                                <div class="nmzp-btn oval recent-item-btn" style="max-width: 108px;" @click="appendProductMessage(item)">发送</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="showinfo == 'orders-box'" class="orders-box">
                      <div class="orders">
                        <div v-for="(item, index) in Orderlist" :key="index" class="orderList">
                          <p class="title clearfix">
                            <span class="fl left">订单号：{{ item.order_id }}</span>
                            <span class="fl left">{{ item.create_time }}</span>
                          </p>
                          <ul class="productList">
                            <li v-for="(goods, i) in item.detail" :key="i" class="productItem clearfix">
                              <div class="imgBox">
                                <router-link :to="{path:'/GoodsDetail',query:{id:goods.goods_id}}" target="_blank" :title="goods.title">
                                  <img v-real-img="goods.imgpath" src="../../assets/images/zwtp.jpg" :alt="goods.title" width="80" height="80">
                                </router-link>
                              </div>
                              <div class="info">
                                <router-link :to="{path:'/GoodsDetail',query:{id:goods.goods_id}}" target="_blank" :title="goods.title">
                                  <p class="elli" :title="goods.title">{{ goods.title }}</p>
                                </router-link>
                                <div class="btns clearfix">
                                  <div class="nmzp-btn panda fr send" style="max-width: 108px;" @click="appendOrderMessage(item,i)">发送</div>
                                </div>
                              </div>
                            </li>
                          </ul>
                          <div class="footer clearfix">
                            <p class="priceBox fl">
                              <span>订单金额：</span>
                              <span class="price">￥{{ item.total_amount }}</span>
                            </p>
                            <span v-if="item.state==0" class="sate fr state0">未发货</span>
                            <span v-if="item.state==1" class="sate fr state1">已发货</span>
                            <span v-if="item.state==2" class="sate fr state2">已收货</span>
                          </div>
                        </div>
                        <!-- <div class="loading">已加载完毕</div> -->
                        <div v-if="Orderlist.length==0" class="loading">暂无订单</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </lemon-imui>
          <!--弹窗聊天记录/新增聊天记录窗体-->
          <el-dialog :title="contactdisplayName" :visible.sync="dialogFormVisibles" width="40%" :modal=true>
            <el-form ref="dataForm">
              <div class="search-bars">
                <input class="search-bar-inputs" placeholder="搜索" v-model="ChatValue" @input="SearchChat(ChatValue)">
              </div>
              <div>
                <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                  <el-tab-pane label="全部" name="1">
                    <div class="lemon-message lemon-message--status-succeed lemon-message-chat" v-for="(item, i) in AllmessageList" :key="i">
                      <div class="lemon-message__avatar">
                        <span class="lemon-avatar" shape="square" style="width: 36px; height: 36px; line-height: 36px; font-size: 18px;">
                          <img v-if="item.uid === user.id" v-real-img="user.avatar" src="../../assets/images/zwtp.jpg" :alt="item.title" width="80" height="80">
                          <img v-else v-real-img="contactavatar" src="../../assets/images/zwtp.jpg" :alt="item.title" width="80" height="80">
                        </span>
                      </div>
                      <div class="lemon-message__inner">
                        <div class="lemon-message__title">
                          <span style="width:250px;float:left;" v-if="item.uid === user.id">{{ user.displayName }}</span>
                          <span style="width:250px;float:left;" v-else>{{ contactdisplayName }}</span>
                          <span style="width:150px;float:right;">{{ item.addtime }}</span>
                        </div>
                        <div class="lemon-message__content-flex">
                          <div v-if="item.filetype === 'text'" class="lemon-message__content">
                            <span v-html="brightenKeyword(item.content, ChatValue)"></span>
                          </div>
                          <div v-if="item.filetype === 'image'" class="lemon-message__content">
                            <a :href="item.content" target="_blank" title="点击下载">
                              <img v-real-img="item.content" src="../../assets/images/zwtp.jpg"/>
                            </a>
                          </div>
                          <video v-if="item.filetype === 'mp4'" width="30%" :src="item.content" controls="controls"></video>
                          <div v-if="item.filetype === 'file'" class="lemon-message__content" style="display:flex;background:#efefef;width:200px">
                            <div class="lemon-message-file__inner">
                              <p class="lemon-message-file__name" v-html="brightenKeyword(item.filename, ChatValue)"></p>
                              <p class="lemon-message-file__byte">{{ (item.filesize/1024).toFixed(2)}}K</p>
                            </div>
                            <a :href="item.content" target="_blank" title="点击下载">
                              <div class="lemon-message-file__sfx">
                                <i class="lemon-icon-attah"></i>
                              </div>
                            </a>
                          </div>
                          <div v-if="item.filetype === 'product'" class="lemon-message__content">
                            <a :href="item.url" target="_blank" :title="item.product.title">
                              <div class="single-temp send" style="height:120px;margin-top:0;">
                                <div class="product-item clearfix">
                                  <div class="pic-wrap">
                                    <img v-real-img="item.product.imgpath" src="../../assets/images/zwtp.jpg" :alt="item.product.title" style="width:80px;height:80px"/>
                                  </div>
                                  <div class="info-wrap">
                                    <div class="title">
                                      <p v-html="brightenKeyword(item.product.title, ChatValue)"></p>
                                    </div>
                                    <div class="label normal"></div>
                                    <div class="footer">
                                      <div class="info-box">
                                        <span class="price">{{item.product.tax_price > 0 ? '¥' + item.product.tax_price : '询价' }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div v-if="item.filetype === 'order'" class="lemon-message__content">
                            <a :href="item.url" target="_blank" :title="item.order.detail[item.order.index].title">
                              <div class="single-temp send" style="height:185px;margin-top:0;">
                                <div class="product-item clearfix">
                                  <div class="ordertitle clearfix">
                                    <span class="fl ordernum">订单号：</span><span class="fl ordernum" v-html="brightenKeyword(item.order.order_id, ChatValue)"></span>
                                    <span class="fl ordertime">{{ item.order.create_time }}</span>
                                  </div>
                                  <div class="pic-wrap">
                                    <img v-real-img="item.order.detail[item.order.index].imgpath" src="../../assets/images/zwtp.jpg" :alt="item.order.detail[item.order.index].title" style="width:80px;height:80px" />
                                  </div>
                                  <div class="info-wrap">
                                    <div class="title">
                                      <p v-html="brightenKeyword(item.order.detail[item.order.index].title, ChatValue)"></p>
                                    </div>
                                    <div class="label normal"></div>
                                    <div class="footer">
                                      <div class="info-box">
                                        <span class="price">{{item.order.detail[item.order.index].tax_price > 0 ? '¥' + item.order.detail[item.order.index].tax_price : '询价' }}</span>
                                        <span v-if="item.order.state === 0" class="sate fr state0">未发货</span>
                                        <span v-if="item.order.state === 1" class="sate fr state1">已发货</span>
                                        <span v-if="item.order.state === 2" class="sate fr state2">已收货</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div class="lemon-message__content-after">
                          </div>
                          <div class="lemon-message__status">
                            <i class="lemon-icon-loading lemonani-spin"></i>
                            <i title="重发消息" class="lemon-icon-prompt" style="color: rgb(255, 37, 37); cursor: pointer;"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="AllmessageList.length==0" class="loading">暂无数据</div>
                  </el-tab-pane>
                  <el-tab-pane label="文件" name="2">
                    <div class="lemon-message lemon-message--status-succeed lemon-message-chat" v-for="(item, i) in FilemessageList" :key="i">
                      <div class="lemon-message__avatar">
                        <span class="lemon-avatar" shape="square" style="width: 36px; height: 36px; line-height: 36px; font-size: 18px;">
                          <img v-if="item.uid === user.id" v-real-img="user.avatar" src="../../assets/images/zwtp.jpg" :alt="item.title" width="80" height="80">
                          <img v-else v-real-img="contactavatar" src="../../assets/images/zwtp.jpg" :alt="item.title" width="80" height="80">
                        </span>
                      </div>
                      <div class="lemon-message__inner">
                        <div class="lemon-message__title">
                          <span style="width:250px;float:left;" v-if="item.uid === user.id">{{ user.displayName }}</span>
                          <span style="width:250px;float:left;" v-else>{{ contactdisplayName }}</span>
                          <span style="width:150px;float:right;">{{ item.addtime }}</span>
                        </div>
                        <div class="lemon-message__content-flex">
                          <div v-if="item.filetype === 'file'" class="lemon-message__content" style="display:flex;background:#efefef;width:200px">
                            <div class="lemon-message-file__inner">
                              <p class="lemon-message-file__name">{{ item.filename }}</p>
                              <p class="lemon-message-file__byte">{{ (item.filesize/1024).toFixed(2)}}K</p>
                            </div>
                            <a :href="item.content" target="_blank" title="点击下载">
                              <div class="lemon-message-file__sfx">
                                <i class="lemon-icon-attah"></i>
                              </div>
                            </a>
                          </div>
                          <div class="lemon-message__content-after">
                          </div>
                          <div class="lemon-message__status">
                            <i class="lemon-icon-loading lemonani-spin"></i>
                            <i title="重发消息" class="lemon-icon-prompt" style="color: rgb(255, 37, 37); cursor: pointer;"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="FilemessageList.length==0" class="loading">暂无数据</div>
                  </el-tab-pane>
                  <el-tab-pane label="图片与视频" name="3">
                    <div class="lemon-message lemon-message--status-succeed lemon-message-chat" v-for="(item, i) in Imgmp4messageList" :key="i">
                      <div class="lemon-message__avatar">
                        <span class="lemon-avatar" shape="square" style="width: 36px; height: 36px; line-height: 36px; font-size: 18px;">
                          <img v-if="item.uid === user.id" v-real-img="user.avatar" src="../../assets/images/zwtp.jpg" :alt="item.title" width="80" height="80">
                          <img v-else v-real-img="contactavatar" src="../../assets/images/zwtp.jpg" :alt="item.title" width="80" height="80">
                        </span>
                      </div>
                      <div class="lemon-message__inner">
                        <div class="lemon-message__title">
                          <span style="width:250px;float:left;" v-if="item.uid === user.id">{{ user.displayName }}</span>
                          <span style="width:250px;float:left;" v-else>{{ contactdisplayName }}</span>
                          <span style="width:150px;float:right;">{{ item.addtime }}</span>
                        </div>
                        <div class="lemon-message__content-flex">
                          <div v-if="item.filetype === 'image'" class="lemon-message__content">
                            <a :href="item.content" target="_blank" title="点击下载">
                              <img v-real-img="item.content" src="../../assets/images/zwtp.jpg"/>
                            </a>
                          </div>
                          <video v-if="item.filetype === 'mp4'" width="30%" :src="item.content" controls="controls"></video>
                          <div class="lemon-message__content-after">
                          </div>
                          <div class="lemon-message__status">
                            <i class="lemon-icon-loading lemonani-spin"></i>
                            <i title="重发消息" class="lemon-icon-prompt" style="color: rgb(255, 37, 37); cursor: pointer;"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="Imgmp4messageList.length==0" class="loading">暂无数据</div>
                  </el-tab-pane>
                  <el-tab-pane label="产品与订单" name="4">
                    <div class="lemon-message lemon-message--status-succeed lemon-message-chat" v-for="(item, i) in ProductordermessageList" :key="i">
                      <div class="lemon-message__avatar">
                        <span class="lemon-avatar" shape="square" style="width: 36px; height: 36px; line-height: 36px; font-size: 18px;">
                          <img v-if="item.uid === user.id" v-real-img="user.avatar" src="../../assets/images/zwtp.jpg" :alt="item.title" width="80" height="80">
                          <img v-else v-real-img="contactavatar" src="../../assets/images/zwtp.jpg" :alt="item.title" width="80" height="80">
                        </span>
                      </div>
                      <div class="lemon-message__inner">
                        <div class="lemon-message__title">
                          <span style="width:250px;float:left;" v-if="item.uid === user.id">{{ user.displayName }}</span>
                          <span style="width:250px;float:left;" v-else>{{ contactdisplayName }}</span>
                          <span style="width:150px;float:right;">{{ item.addtime }}</span>
                        </div>
                        <div class="lemon-message__content-flex">
                          <div v-if="item.filetype === 'product'" class="lemon-message__content">
                            <a :href="item.url" target="_blank" :title="item.product.title">
                              <div class="single-temp send" style="height:120px;margin-top:0;">
                                <div class="product-item clearfix">
                                  <div class="pic-wrap">
                                    <img v-real-img="item.product.imgpath" src="../../assets/images/zwtp.jpg" :alt="item.product.title" style="width:80px;height:80px" />
                                  </div>
                                  <div class="info-wrap">
                                    <div class="title">
                                      <p>{{ item.product.title }}</p>
                                    </div>
                                    <div class="label normal"></div>
                                    <div class="footer">
                                      <div class="info-box">
                                        <span class="price">{{item.product.tax_price > 0 ? '¥' + item.product.tax_price : '询价' }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div v-if="item.filetype === 'order'" class="lemon-message__content">
                            <a :href="item.url" target="_blank" :title="item.order.detail[item.order.index].title">
                              <div class="single-temp send" style="height:185px;margin-top:0;">
                                <div class="product-item clearfix">
                                  <div class="ordertitle clearfix">
                                    <span class="fl ordernum">订单号: {{ item.order.order_id }}</span>
                                    <span class="fl ordertime">{{ item.order.create_time }}</span>
                                  </div>
                                  <div class="pic-wrap">
                                    <img v-real-img="item.order.detail[item.order.index].imgpath" src="../../assets/images/zwtp.jpg" :alt="item.order.detail[item.order.index].title" style="width:80px;height:80px" />
                                  </div>
                                  <div class="info-wrap">
                                    <div class="title">
                                      <p>{{ item.order.detail[item.order.index].title }}</p>
                                    </div>
                                    <div class="label normal"></div>
                                    <div class="footer">
                                      <div class="info-box">
                                        <span class="price">{{item.order.detail[item.order.index].tax_price > 0 ? '¥' + item.order.detail[item.order.index].tax_price : '询价' }}</span>
                                        <span v-if="item.order.state === 0" class="sate fr state0">未发货</span>
                                        <span v-if="item.order.state === 1" class="sate fr state1">已发货</span>
                                        <span v-if="item.order.state === 2" class="sate fr state2">已收货</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div class="lemon-message__content-after">
                          </div>
                          <div class="lemon-message__status">
                            <i class="lemon-icon-loading lemonani-spin"></i>
                            <i title="重发消息" class="lemon-icon-prompt" style="color: rgb(255, 37, 37); cursor: pointer;"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="ProductordermessageList.length==0" class="loading">暂无数据</div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-form>
          </el-dialog>
          <!--弹窗聊天记录/新增会员信息窗体-->
          <el-dialog :title="titles" :visible.sync="dialogFormVisibless" style="width:670px;padding-left:28%;" :modal=true>
            <div class="product-item-user clearfix-user">
              <div class="pic-wrap-user">
                <img v-real-img="userinfo.headimgurl" src="../../assets/images/zwtp.jpg" :alt="userinfo.name" />
              </div>
              <div class="info-wrap-user">
                <div class="title-user"><p>{{ userinfo.name }}</p></div>
                <div class="footer-user">
                  <div class="info-box-user">电话：<span class="price-user">{{ userinfo.tel }}</span></div>
                </div>
                <div class="footer-user">
                  <div class="info-box-user">公司名称：<span class="price-user">{{ userinfo.company_name }}</span></div>
                </div>
                <div class="footer-user">
                  <div class="info-box-user">服务部名称：<span class="price-user">{{ userinfo.plant_name }}</span></div>
                </div>
              </div>
            </div>
          </el-dialog>
          <!--弹窗转接客服窗体-->
          <el-dialog :title="titless" :visible.sync="dialogFormVisiblesss" width="20%" :modal=true>
            <el-select v-model="customerservice" placeholder="请选择客服人员" style="width:100%">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisiblesss = false">取 消</el-button>
              <el-button type="primary" @click="confirmService(selectService)">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api/service'
import apiuser from '@/api/user'
import apiorder from '@/api/order'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import lemonMessageMp4 from './lemon-message-mp4'
import lemonMessageProduct from './lemon-message-product'
import lemonMessageOrder from './lemon-message-order'
import QQIMUI from './qq'
import packageData from '../../../package.json'
import EmojiData from './database/emoji'
Vue.component(lemonMessageMp4.name, lemonMessageMp4)
Vue.component(lemonMessageProduct.name, lemonMessageProduct)
Vue.component(lemonMessageOrder.name, lemonMessageOrder)
Vue.component(QQIMUI.name, QQIMUI)

const getTime = () => {
  return new Date().getTime()
}
const generateRandId = () => {
  return Math.random().toString(36).substr(-8)
}
const generateMessage = (toContactId = '', fromUser, messageList) => {
  if (!fromUser) {
    fromUser = {
      id: '1',
      displayName: 'June',
      avatar: ''
    }
  }
  return {
    id: messageList.id,
    status: 'succeed',
    type: messageList.filetype,
    sendTime: parseInt(messageList.time),
    content: messageList.content,
    fileSize: parseInt(messageList.filesize),
    fileName: messageList.filename,
    toContactId,
    fromUser
  }
}

export default {
  name: 'Service',
  data () {
    return {
      contactid: '',
      contactdisplayName: '',
      contactavatar: '',
      titles: '',
      theme: 'default',
      // 左边右键后的内容
      contactContextmenu: [
        {
          text: '会员信息',
          click: (e, instance, hide) => {
            const { contact } = instance
            this.titles = contact.displayName
            this.dialogFormVisibless = true
            this.getUserInfo(contact.id)
          }
        },
        {
          text: '删除该聊天',
          click: (e, instance, hide) => {
            const { IMUI, contact } = instance
            IMUI.updateContact({
              id: contact.id,
              lastContent: null
            })
            if (IMUI.currentContactId === contact.id) { IMUI.changeContact(null) }
            hide()
          }
        },
        {
          text: '设置备注',
          click: (e, instance, hide) => {
            const { contact } = instance
            this.updateNickname(contact)
          }
        },
        {
          text: '转接客服',
          click: (e, instance, hide) => {
            const { contact } = instance
            this.customerServices(contact)
          },
          visible: () => {
            if (this.current_user.is_service === 1) {
              return true
            } else {
              return false
            }
          }
        }
      ],
      contextmenu: [
        {
          click: (e, instance, hide) => {
            const { IMUI, message } = instance
            const data = {
              id: generateRandId(),
              type: 'event',
              // 使用 jsx 时 click必须使用箭头函数（使上下文停留在vue内）
              content: (
                <div>
                  <span>
                    你撤回了一条消息{' '}
                  <span
                    v-show={message.type === 'text'}
                    style="color:#333;cursor:pointer"
                    content={message.content}
                    on-click={(e) => {
                      IMUI.setEditorValue(e.target.getAttribute('content'))
                    }}
                  >
                      重新编辑
                  </span>
                  </span>
                </div>
              ),

              toContactId: message.toContactId,
              sendTime: getTime()
            }
            IMUI.removeMessage(message.id)
            IMUI.appendMessage(data, true)
            hide()
          },
          visible: (instance) => {
            return instance.message.fromUser.id === this.user.id
          },
          text: '撤回消息'
        },
        // {
        //   click: (e, instance, hide) => {
        //     this.$message({
        //       message: '正在建设中',
        //       type: 'warning'
        //     })
        //   },
        //   visible: (instance) => {
        //     return instance.message.fromUser.id !== this.user.id
        //   },
        //   text: '举报'
        // },
        // {
        //   text: '转发'
        // },
        // {
        //   click: (e, instance, hide) => {
        //   },
        //   visible: (instance) => {
        //     return instance.message.type === 'text'
        //   },
        //   text: '复制文字'
        // },
        {
          click: (e, instance, hide) => {
            window.open(instance.message.content, '_blank')
          },
          visible: (instance) => {
            return instance.message.type === 'image'
          },
          text: '下载图片'
        },
        {
          click: (e, instance, hide) => {
            window.open(instance.message.content, '_blank')
          },
          visible: (instance) => {
            return instance.message.type === 'file'
          },
          text: '下载文件'
        },
        {
          click: (e, instance, hide) => {
            const { IMUI, message } = instance
            IMUI.removeMessage(message.id)
            hide()
          },
          icon: 'lemon-icon-folder',
          color: 'red',
          text: '删除'
        }
      ],
      packageData,
      hideMenuAvatar: false,
      hideMenu: false,
      hideMessageName: false,
      hideMessageTime: true,
      user: {
        id: '1',
        displayName: 'June',
        avatar: ''
      },
      contactList: [],
      ws: null,
      showinfo: 'product-info',
      active: 'active',
      listQuery: {
        limit: 30
      },
      OrderlistQuery: {
        limit: 10,
        order: 'create_time',
        filters: {
        }
      },
      Historylist: [],
      Orderlist: [],
      SearchValue: '',
      dialogFormVisibles: false,
      activeName: '1',
      ChatValue: '',
      AllmessageList: [],
      FilemessageList: [],
      Imgmp4messageList: [],
      ProductordermessageList: [],
      SaveAllmessageList: [],
      dialogFormVisibless: false,
      titless: '转接客服',
      dialogFormVisiblesss: false,
      userinfo: [],
      customerservice: '',
      options: [],
      selectService: ''
    }
  },
  created () {
    this.user.id = this.current_user.id
    this.user.displayName = this.current_user.name
    this.user.avatar = this.current_user.headimgurl
    var that = this
    this.ws = new WebSocket('wss://serv.nmzp.com/wss')
    // 测试
    var id = this.current_user.id
    // 这里我们把url中传过来的id和uid进行绑定
    this.ws.onopen = function () {
      console.log('连接成功')
      that.ws.send(JSON.stringify({type: 'bind', uid: id, mode: 'bind'}))
      // 将接收到的数据包装成下面的样子
      window.setInterval(function () {
        console.log('连接成功')
        that.ws.send(JSON.stringify({type: 'bind', uid: id, mode: 'bind'}))
      }, 30000)
    }
    this.ws.onclose = function () {
      console.log('关闭了')
    }
    // 重要：onmessage workermanchange-contact连接测试
    this.ws.onmessage = function (e) {
      // 两次绑定我是没有想到的，艹
      const { IMUI } = that.$refs
      var data = JSON.parse(e.data)
      console.log(data)
      var result = {
        id: data.id,
        status: 'succeed',
        type: data.type,
        sendTime: data.sendTime,
        content: data.content,
        toContactId: data.fromUser.id,
        mode: data.mode,
        fileSize: data.fileSize,
        fileName: data.fileName,
        fromUser: {
          // 如果 id == this.user.id消息会显示在右侧，否则在左侧
          // 这个id就是用来区分显示在左边还是右边的
          // 也很奇怪，其实这里什么值都是可以的
          id: data.fromUser.id,
          displayName: data.fromUser.displayName,
          avatar: data.fromUser.avatar
        }}
      console.log('单聊')
      console.log(result)
      if (result.mode === 'group') {
        const result = {
          id: data.id,
          status: 'succeed',
          type: data.type,
          sendTime: data.sendTime,
          content: data.content,
          toContactId: data.toContactId,
          mode: data.mode,
          group_groupmember: data.group_groupmember,
          group_name: data.group_name,
          fileSize: data.fileSize,
          fileName: data.fileName,
          fromUser: {
            // 如果 id == this.user.id消息会显示在右侧，否则在左侧
            id: data.fromUser.id,
            displayName: data.fromUser.displayName,
            avatar: data.fromUser.avatar
          }

        }
        console.log('群聊')
        console.log(result)
      }
      if (result.fromUser.avatar === 'https://serv.nmzp.com/uploads/1/image/20220711/7d3cfc5335c051082f6ac6cccce9ebc1.png' && result.fromUser.displayName === '游客') {
        // 查询id是否存在
        var isid = that.contactList.findIndex(item => item.id === result.fromUser.id)
        if (isid < 0) {
          var contactData = {
            id: result.fromUser.id,
            displayName: result.fromUser.displayName,
            avatar: result.fromUser.avatar,
            index: '',
            unread: 1,
            lastSendTime: result.sendTime,
            lastContent: result.content
          }
          that.contactList.push({...contactData})
          IMUI.initContacts(that.contactList)
        }
      }
      setTimeout(() => {
        if (data.toContactId !== data.fromUser.id) {
          IMUI.appendMessage(result, true)
        }
      }, 50)
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  mounted () {
    // 查询用户列表
    var contactData = {
      id: '',
      displayName: '',
      avatar: '',
      index: '',
      unread: 0,
      lastSendTime: 0,
      lastContent: ''
    }
    api.getUserlist({'id': this.current_user.id, 'is_service': this.current_user.is_service}).then((response) => {
      if (response.code === 20000) {
        let forlist = response.items
        for (var i = 0; i < forlist.length; i++) {
          if (forlist[i]['filetype'] === 'image') {
            forlist[i]['lastContent'] = '[图片]'
          } else if (forlist[i]['filetype'] === 'file') {
            forlist[i]['lastContent'] = '[文件]'
          } else if (forlist[i]['filetype'] === 'text') {
            forlist[i]['lastContent'] = forlist[i]['lastContent']
          } else if (forlist[i]['filetype'] === 'mp4') {
            forlist[i]['lastContent'] = '[视频]'
          } else if (forlist[i]['filetype'] === 'product') {
            forlist[i]['lastContent'] = '[产品]'
          } else if (forlist[i]['filetype'] === 'order') {
            forlist[i]['lastContent'] = '[订单]'
          }
          contactData = {
            id: forlist[i]['id'],
            displayName: forlist[i]['name'],
            avatar: forlist[i]['headimgurl'],
            index: forlist[i]['index'],
            unread: 0,
            lastSendTime: parseInt(forlist[i]['lastSendTime']),
            lastContent: forlist[i]['lastContent']
          }
          this.contactList.push({...contactData})
        }
      } else {
        this.contactList = []
      }
    })
    const { IMUI } = this.$refs
    // 默认进来是ID为1的用户
    // if (this.contactList.length > 0) {
    //   setTimeout(() => {
    //     IMUI.changeContact(this.contactList[0]['id'])
    //   }, 500)
    // }
    IMUI.setLastContentRender('event', (message) => {
      return `[文本]`
    })
    IMUI.initContacts(this.contactList)
    IMUI.initMenus([
      {
        name: 'messages'
      },
      {
        name: 'contacts'
      }
    ])
    IMUI.initEditorTools([
      {
        name: 'emoji'
      },
      {
        name: 'uploadFile'
      },
      {
        name: 'uploadImage'
      },
      {
        name: 'test',
        click: () => {
          this.activeName = '1'
          this.dialogFormVisibles = true
        },
        render: () => {
          return <i class='el-icon-chat-dot-round' title="聊天记录" style="font-size:20px;line-height:26px;"></i>
        }
      }
    ])
    IMUI.initEmoji(EmojiData)
    IMUI.setLastContentRender('mp4', (message) => {
      return <span>[视频]</span>
    })
    IMUI.setLastContentRender('product', (message) => {
      return <span>[产品]</span>
    })
    IMUI.setLastContentRender('order', (message) => {
      return <span>[订单]</span>
    })
    // 获取浏览记录
    this.getMyHistory()
    // 获取我的订单
    this.getMyOrder()
    // 获取客服人员
    this.getCustomerService()
  },
  methods: {
    changeTheme () {
      this.theme = this.theme === 'default' ? 'blue' : 'default'
    },
    handleMenuAvatarClick () {
      // console.log('Event:menu-avatar-click')
    },
    handleMessageClick (e, key, message, instance) {
      // alert('点击了消息', e, key, message)
      if (key === 'status') {
        instance.updateMessage({
          id: message.id,
          status: 'going',
          content: '正在重新发送消息...'
        })
        setTimeout(() => {
          instance.updateMessage({
            id: message.id,
            status: 'succeed',
            content: '发送成功'
          })
        }, 2000)
      }
    },
    changeMenuAvatarVisible () {
      this.hideMenuAvatar = !this.hideMenuAvatar
    },
    changeMenuVisible () {
      this.hideMenu = !this.hideMenu
    },
    changeMessageNameVisible () {
      this.hideMessageName = !this.hideMessageName
    },
    changeMessageTimeVisible () {
      this.hideMessageTime = !this.hideMessageTime
    },
    removeMessage () {
      const { IMUI } = this.$refs
      const messages = IMUI.getCurrentMessages()
      const id = messages[messages.length - 1].id
      if (messages.length > 0) {
        IMUI.removeMessage(id)
      }
    },
    updateMessage () {
      const { IMUI } = this.$refs
      const messages = IMUI.getCurrentMessages()
      const message = messages[messages.length - 1]
      if (messages.length > 0) {
        const update = {
          id: message.id,
          status: 'succeed',
          type: 'file',
          fileName: '被修改成文件了.txt',
          fileSize: '4200000'
        }
        if (message.type === 'event') {
          update.fromUser = this.user
        }
        IMUI.updateMessage(update)
        IMUI.messageViewToBottom()
      }
    },
    appendCustomMessage () {
      const { IMUI } = this.$refs
      const message = {
        id: generateRandId(),
        status: 'succeed',
        type: 'voice',
        sendTime: getTime(),
        content: '语音消息',
        params1: '1',
        params2: '2',
        toContactId: 1,
        fromUser: this.user
      }
      IMUI.appendMessage(message, true)
    },
    appendProductMessage (row) {
      const { IMUI } = this.$refs
      const message = {
        status: 'succeed',
        type: 'product',
        sendTime: getTime(),
        content: JSON.stringify(row),
        toContactId: this.contactid,
        mode: 'single',
        fileSize: null,
        fileName: null,
        fromUser: this.user
      }
      IMUI.appendMessage(message, true)
      this.ws.send(JSON.stringify(message))
    },
    appendOrderMessage (row, i) {
      const { IMUI } = this.$refs
      row['index'] = i
      const message = {
        status: 'succeed',
        type: 'order',
        sendTime: getTime(),
        content: JSON.stringify(row),
        toContactId: this.contactid,
        mode: 'single',
        fileSize: null,
        fileName: null,
        fromUser: this.user
      }
      IMUI.appendMessage(message, true)
      this.ws.send(JSON.stringify(message))
    },
    appendEventMessage () {
      const { IMUI } = this.$refs
      const message = {
        id: generateRandId(),
        type: 'event',
        content: (
          <span>
            邀请你加入群聊{' '}
          <span
            style="color:#333;cursor:pointer"
            on-click={() => alert('OK')}
          >
              接受
          </span>
          </span>
        ),
        toContactId: 1,
        sendTime: getTime()
      }
      IMUI.appendMessage(message, true)
    },
    changeDrawer (contact, instance) {
      instance.changeDrawer({
        // width: 240,
        // height: '90%',
        // offsetX: 0,
        // offsetY: 0,
        // position: 'center',
        // inside: true,
        // offsetX: -280,
        // offsetY: -100,
        render: () => {
          return (
            <div class="drawer-content">
              <p>
                <b>自定义抽屉</b>
              </p>
              <p>{contact.displayName}</p>
            </div>
          )
        }
      })
    },
    // 重要  切换视窗时可以用，但是好像只能获取信息
    handleChangeContact (contact, instance) {
      instance.updateContact({
        id: contact.id,
        unread: 0
      })
      // this.handlePullMessages()
      this.contactid = contact.id
      this.contactdisplayName = contact.displayName
      this.contactavatar = contact.avatar
      // console.log(contact)
      // console.info( instance.getCurrentMessages())
      // console.info((instance._data.currentMessages))
      // console.log(" 当前窗口所有消息 "+getCurrentMessages());
      for (var i = 0; i < this.contactList.length; i++) {
        if (contact.id !== this.contactList[i]['id']) {
          if (this.contactList[i]['lastContent'] === ' ') {
            this.contactList[i]['lastContent'] = null
          }
        }
      }
      this.SearchValue = ''
      this.$refs.IMUI.initContacts(this.contactList)
      this.getAllChatlist(contact.id)
      instance.closeDrawer()
    },
    // 重要 发送数据的地方 等于点击发送的按钮
    handleSend (message, next, file) {
    // 发送东西前我们要初始化登陆的id和name
      // const { IMUI } = this.$refs
      // IMUI.changeContact(this.contactid)
      var id = this.current_user.id
      var name = this.current_user.name
      var avatar = this.current_user.headimgurl
      message['fromUser'] = {
        id: id,
        displayName: name,
        avatar: avatar
      }
      // 存放群聊组和里面的成员
      var datagroup = [
        {
          groupname: 1,
          groupmember: [1, 26, 59, 69]
        }
      ]

      // 群聊消息处理实例示例
      datagroup.forEach((value, index) => {
        if (value.groupname === message.toContactId) {
          message['mode'] = 'group'
          message['group_groupmember'] = value.groupmember
          message['group_name'] = value.groupname
        }
      })
      if (message['mode'] !== 'group') {
        message['mode'] = 'single'
      }
      /* if(message.toContactId=='contact-1'){
         message['mode']='group';

      }//个人消息
      else{
        message['mode']='single';
      } */
      message['status'] = 'succeed'
      // 查询数据
      for (var i = 0; i < this.contactList.length; i++) {
        if (message.toContactId === this.contactList[i]['id']) {
          if (this.contactList[i].displayName === '游客' && this.contactList[i].avatar === 'https://serv.nmzp.com/uploads/1/image/20220711/7d3cfc5335c051082f6ac6cccce9ebc1.png') {
            message['mode'] = 'tourist'
          }
        }
      }
      console.log(message)
      if (file) {
        var suffix = file.name.split('.')[file.name.split('.').length - 1]
        if (suffix !== 'jpg' && suffix !== 'gif' && suffix !== 'jpeg' && suffix !== 'png' && suffix !== 'mp3' && suffix !== 'mp4' && suffix !== 'xls' && suffix !== 'xlsx' && suffix !== 'doc' && suffix !== 'docx' && suffix !== 'txt') {
          this.$message({
            message: '此文件不允许上传',
            type: 'warning'
          })
          return false
        }
        if (suffix === 'mp4') {
          message['type'] = suffix
        }
        const formData = new FormData()
        formData.append('file', file)
        api.ChatUpload(formData).then((response) => {
          if (response.code === 20000) {
            message['content'] = response.message
            this.ws.send(JSON.stringify(message))
          }
        })
      } else {
        this.ws.send(JSON.stringify(message))
      }
      // 经过多少秒之后发送出去
      setTimeout(() => {
        next()
      }, 10)
    },
    // 重要：当切换聊天对象 但是好像只能初始化的时候用 用来模拟缓存
    handlePullMessages (contact, next, instance) {
      const otheruser = {
        id: contact.id,
        displayName: contact.displayName,
        avatar: contact.avatar
      }
      // 聊天数据
      var messageList = []
      if (otheruser.displayName === '游客' && otheruser.avatar === 'https://serv.nmzp.com/uploads/1/image/20220711/7d3cfc5335c051082f6ac6cccce9ebc1.png') {
        api.getChattourlist({'uid': instance.user.id, 'sid': contact.id}).then((response) => {
          if (response.code === 20000) {
            messageList = response.items
          } else {
            messageList = []
          }
        })
      } else {
        api.getChatlist({'uid': instance.user.id, 'sid': contact.id}).then((response) => {
          if (response.code === 20000) {
            messageList = response.items
          } else {
            messageList = []
          }
        })
      }
      setTimeout(() => {
        var messages = []
        for (var i = 0; i < messageList.length; i++) {
          if (messageList[i]['uid'] === instance.user.id) {
            messages.push(generateMessage(instance.currentContactId, this.user, messageList[i]))
          } else if (messageList[i]['uid'] === contact.id) {
            messages.push(generateMessage(instance.currentContactId, otheruser, messageList[i]))
          }
        }
        let isEnd = false
        if (instance.getMessages(instance.currentContactId).length + messages.length > 1) {
          isEnd = true
        }
        isEnd = true
        next(messages, isEnd)
      }, 500)
    },
    // 比较少 触发 侧侧边栏
    handleChangeMenu () {
    },
    openCustomContainer () {
    },
    showproductinfo (e) {
      this.showinfo = e
    },
    getMyHistory () {
      apiuser.getMyHistory(this.listQuery).then(response => {
        let forlist = response.items
        this.Historylist = forlist
      })
    },
    getMyOrder () {
      apiorder.Query(this.OrderlistQuery).then(response => {
        let forlist = response.items
        this.Orderlist = forlist
      })
    },
    SearchContacts (value) {
      if (value !== '') {
        // 所有联系人
        const search = this.fuzzyQuery(this.contactList, value)
        for (var i = 0; i < search.length; i++) {
          if (search[i]['lastContent'] === '' || search[i]['lastContent'] === null) {
            search[i]['lastContent'] = ' '
          }
        }
        this.$refs.IMUI.initContacts(search)
      } else {
        this.$refs.IMUI.initContacts(this.contactList)
      }
    },
    fuzzyQuery (list, keyWord) {
      var arr = []
      for (var i = 0; i < list.length; i++) {
        if (list[i]['displayName']) {
          if (list[i]['displayName'].indexOf(keyWord) >= 0) {
            arr.push(list[i])
          }
        }
      }
      return arr
    },
    fuzzyQuerycontent (list, keyWord) {
      var arr = []
      for (var i = 0; i < list.length; i++) {
        if (list[i]['filetype'] === 'text') {
          if (list[i]['content'].toLowerCase().indexOf(keyWord.toLowerCase()) >= 0) {
            arr.push(list[i])
          }
        } else if (list[i]['filetype'] === 'file') {
          if (list[i]['filename'].toLowerCase().indexOf(keyWord.toLowerCase()) >= 0) {
            arr.push(list[i])
          }
        } else if (list[i]['filetype'] === 'product') {
          if (list[i]['product']['title'].toLowerCase().indexOf(keyWord.toLowerCase()) >= 0) {
            arr.push(list[i])
          }
        } else if (list[i]['filetype'] === 'order') {
          if (list[i]['order']['order_id'].toLowerCase().indexOf(keyWord.toLowerCase()) >= 0) {
            arr.push(list[i])
          } else if (list[i]['order']['detail'][list[i]['order']['index']]['title'].toLowerCase().indexOf(keyWord.toLowerCase()) >= 0) {
            arr.push(list[i])
          }
        }
      }
      return arr
    },
    handleClick (tab, event) {
      this.FilemessageList = []
      this.Imgmp4messageList = []
      this.ProductordermessageList = []
      const AllmessageList = this.AllmessageList
      for (var i = 0; i < AllmessageList.length; i++) {
        if (AllmessageList[i].filetype === 'file') {
          this.FilemessageList.push(AllmessageList[i])
        } else if (AllmessageList[i].filetype === 'image' || AllmessageList[i].filetype === 'mp4') {
          this.Imgmp4messageList.push(AllmessageList[i])
        } else if (AllmessageList[i].filetype === 'product' || AllmessageList[i].filetype === 'order') {
          this.ProductordermessageList.push(AllmessageList[i])
        }
      }
    },
    SearchChat (value) {
      this.activeName = '1'
      const AllmessageList = this.SaveAllmessageList
      if (value !== '') {
        const SearchChatlist = this.fuzzyQuerycontent(AllmessageList, value)
        this.AllmessageList = SearchChatlist
      } else {
        this.AllmessageList = this.SaveAllmessageList
      }
    },
    getAllChatlist (row) {
      this.messageList = []
      this.SaveAllmessageList = []
      if ((typeof row === 'string') && row.constructor === String) {
        api.getChattourlist({ uid: this.user.id, sid: this.contactid }).then(res => {
          if (res.code === 20000) {
            this.AllmessageList = res.items
            this.SaveAllmessageList = res.items
            for (var i = 0; i < this.AllmessageList.length; i++) {
              if (this.AllmessageList[i]['filetype'] === 'product') {
                this.AllmessageList[i]['product'] = JSON.parse(this.AllmessageList[i]['content'])
                this.AllmessageList[i]['url'] = 'https://www.nmzp.com/#/GoodsDetail?id=' + this.AllmessageList[i]['product'].goods_id
              } else if (this.AllmessageList[i]['filetype'] === 'order') {
                this.AllmessageList[i]['order'] = JSON.parse(this.AllmessageList[i]['content'])
                this.AllmessageList[i]['url'] = 'https://www.nmzp.com/#/GoodsDetail?id=' + this.AllmessageList[i]['order']['detail'][this.AllmessageList[i]['order']['index']].goods_id
              }
            }
          } else {
            this.AllmessageList = []
          }
        })
      } else {
        api.getChatlist({ uid: this.user.id, sid: this.contactid }).then(res => {
          if (res.code === 20000) {
            this.AllmessageList = res.items
            this.SaveAllmessageList = res.items
            for (var i = 0; i < this.AllmessageList.length; i++) {
              if (this.AllmessageList[i]['filetype'] === 'product') {
                this.AllmessageList[i]['product'] = JSON.parse(this.AllmessageList[i]['content'])
                this.AllmessageList[i]['url'] = 'https://www.nmzp.com/#/GoodsDetail?id=' + this.AllmessageList[i]['product'].goods_id
              } else if (this.AllmessageList[i]['filetype'] === 'order') {
                this.AllmessageList[i]['order'] = JSON.parse(this.AllmessageList[i]['content'])
                this.AllmessageList[i]['url'] = 'https://www.nmzp.com/#/GoodsDetail?id=' + this.AllmessageList[i]['order']['detail'][this.AllmessageList[i]['order']['index']].goods_id
              }
            }
          } else {
            this.AllmessageList = []
          }
        })
      }
    },
    brightenKeyword (val, keyword) {
      // 搜索高亮
      if (keyword.length > 0) {
        val = val + ''
        if (val.indexOf(keyword) !== -1 && keyword !== '') {
          val = val.replace(
            new RegExp(keyword, 'gi'),
            '<font color="#409EFF">' + keyword + '</font>'
          )
        }
        return val
      } else {
        return val
      }
    },
    updateNickname (row) {
      this.$prompt('请输入备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.displayName,
        inputErrorMessage: '输入不能为空',
        inputValidator: (value) => { // 点击按钮时，对文本框里面的值进行验证
          if (!value) {
            return '输入不能为空'
          }
        }
      }).then(({ value }) => {
        api.updateNickname({uid: this.current_user.id, sid: row.id, displayname: value}).then((response) => {
          if (response.code === 20000) {
            this.$refs.IMUI.updateContact({
              id: row.id,
              unread: 0,
              displayName: value,
              lastSendTime: getTime(),
              lastContent: row.lastContent
            })
          }
        })
      }).catch(() => {})
    },
    getUserInfo (id) {
      api.getUserInfo({id: id}).then((response) => {
        if (response.code === 20000) {
          this.userinfo = response.items
        }
      })
    },
    customerServices (row) {
      this.selectService = row
      this.dialogFormVisiblesss = true
    },
    getCustomerService () {
      if (this.current_user.is_service === 1) {
        api.getCustomerService({id: this.current_user.id}).then((response) => {
          if (response.code === 20000) {
            this.options = response.items
          }
        })
      }
    },
    confirmService (row) {
      api.confirmService({uid: this.user.id, sid: row.id, transferid: this.customerservice}).then((response) => {
        if (response.code === 20000) {
          this.$message({
            type: 'success',
            message: '转接客服成功!'
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.serviceheader {
  background-color: #5178b5;
  position: relative;
  width: 100%;
  height: calc(100vh);
  padding-top: 5%;
  box-sizing: border-box;
  opacity: 1;
}
.cover {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #ddd;
}
.slot-group {
  width: 300px;
  border-left: 1px solid #ddd;
  height: 100%;
  background: #fff;
}
.nmzp-right-pane {
  float: left;
  box-sizing: border-box;
  width: 300px;
}
.nmzp-right-tabs {
  box-sizing: border-box;
  width: 100%;
  height: 42px;
}
.nmzp-tabs {
  box-sizing: border-box;
  background-color: #f8f8f8;
  white-space: nowrap;
}
.nmzp-tabs .nmzp-tab.active {
  background-color: #fff;
  border-bottom: 0 none;
  color: #436aa6;
  border-top: 2px solid #436aa6;
}
.clearfix:after {
  clear: both;
}
.nmzp-tabs .nmzp-tab {
  float: left;
  box-sizing: border-box;
  height: 42px;
  line-height: 42px;
  border-top: 2px solid #f8f8f8;
  text-align: center;
  color: #5a606b;
  font-size: 12px;
  cursor: pointer;
  user-select: none;
}
.nmzp-right-content {
  position: relative;
}
.product-info {
  padding: 7px;
  height: 100%;
  box-sizing: border-box;
  padding-right: 0px;
}
.nmzp-underline-tabs {
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
}
.nmzp-underline-tabs .nmzp-underline-tab {
  float: left;
  box-sizing: border-box;
  height: 25px;
  line-height: 14px;
  text-align: center;
  color: #5a606b;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nmzp-underline-tabs .nmzp-underline-tab-content.active {
  border-bottom: 2px solid #436aa6;
}
.nmzp-underline-tabs .nmzp-underline-tab-content {
  display: inline-block;
  padding-bottom: 9px;
}
.recent-block {
  overflow-x: hidden;
  overflow-y: auto;
}
.recent-block .recent-item {
  padding: 20px 0 20px 0;
  border-bottom: 1px solid #ddd;
}
.recent-block .recent-item .img-box {
  float: left;
  width: 60px;
  height: 60px;
  cursor: pointer;
}
.recent-block .recent-item-details {
  position: relative;
  margin-left: 71px;
  height: 60px;
  margin-top: -25px;
}
.recent-block .recent-item-title {
  font-size: 12px;
  color: #1c2229;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
  padding: 0 8px 0 0;
  font-weight: 500;
  cursor: pointer;
}
.ellipsis2-for-webkit, .ellipsis3-for-webkit {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.ellipsis2-for-webkit {
    -webkit-line-clamp: 2;
}
.recent-block .recent-item-price {
    position: absolute;
    bottom: 0;
    font-size: 14px;
    color: #436aa6;
    line-height: 14px;
}
.recent-block .recent-item-btn {
  position: absolute;
  right: 0;
  bottom: -6px;
  width: 46px;
  height: 24px;
  line-height: 20px;
  padding: 0;
  font-size: 12px;
  color: #343036;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.nmzp-btn.oval {
  border-radius: 4px;
  background: #fff;
  color: #a1a6af;
  border: 1px solid #ddd;
}
.nmzp-btn {
  box-sizing: border-box;
  height: 26px;
  padding: 0 12px;
  line-height: 26px;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  font-size: 12px;
  background-color: #436aa6;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.orders-box {
  height: 639px;
  overflow-x: hidden;
  overflow-y: hidden;
  background: #faf9f9;
  margin-top: -40px;
}
.orders-box .orders {
  height: 639px;
  overflow-y: auto;
}
.orderList {
  font-size: 13px;
  padding: 0 10px;
  color: #5a606b;
  line-height: 17px;
  margin-bottom: 10px;
  background: #fff;
}
.orderList .title {
  padding: 18px 0 8px;
  border-bottom: 1px solid #f2f2f2;
}
.fl {
  float: left;
}
.orderList .title .right {
  color: #a1a6af;
}
.productItem .imgBox {
  width: 80px;
  height: 80px;
  border: 1px solid #f2f2f2;
  float: left;
  cursor: pointer;
}
.productItem .info {
  padding-left: 93px;
  font-size: 12px;
  color: #1c2229;
  line-height: 20px;
}
.productItem .info .elli {
  height: 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  cursor: pointer;
  color: #1c2229;
}
.send {
  background: #faf9f9;
  border: 1px solid #d9d9d9;
  margin-top: 20px;
  line-height: 20px;
  height: 22px;
}
.nmzp-btn.panda {
  background: #fff;
  color: #343036;
  border: 1px solid #d9d9d9;
}
.footer {
  padding: 10px 0;
}
.priceBox {
  font-size: 12px;
  margin-top: 2px;
}
.priceBox .price {
  color: #436aa6;
}

.sate {
  border-radius: 2px;
  font-size: 12px;
  display: inline-block;
  padding: 4px 11px;
  line-height: 15px;
}
.state0 {
  color: #f23030;
  background: #f2f2f2;
}
.state1 {
  color: #436aa6;
  background: #ffeded;
}
.state2 {
  color: #5a606b;
  background: #ffeded;
}
.loading {
  text-align: center;
  margin-bottom: 10px;
}
.search-bar {
  width: 225px;
  height: 24px;
  box-sizing: border-box;
  margin: 14px;
}
.search-bar-input {
  outline: 0 none;
  height: 24px;
  box-sizing: border-box;
  line-height: 24px;
  width: 100%;
  border-radius: 4px;
  border: 0;
  font-size: 12px;
  padding: 0 5px 0 30px;
  background: url('../../assets/images/ss_img01.png') no-repeat #fff 7px 4px;
}
.search-bars {
  width: 100%;
  height: 30px;
  box-sizing: border-box;
  margin: 0 auto;
}
.search-bar-inputs {
  outline: 0 none;
  height: 30px;
  box-sizing: border-box;
  line-height: 24px;
  width: 100%;
  border-radius: 4px;
  border: 0;
  font-size: 12px;
  padding: 0 5px 0 30px;
  background: url('../../assets/images/ss_img01.png') no-repeat #efefef 9px 7px;
}
.el-tab-pane {
  height: 500px;
  overflow-y: auto;
}
.lemon-message-chat {
  border-bottom: 1px solid #ddd;
}
.product-item-user {
  margin-top: -30px;
  height: 100px;
}
.pic-wrap-user {
  float: left;
  width: 80px;
  height: 80px;
}
.pic-wrap-user img {
  width: 100%;
  height: 100%;
}
.info-wrap-user {
  width: 200px;
  float: left;
  margin-left: 10px;
}
.info-wrap-user .title-user {
  color: #000;
  line-height: 1.2;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.info-box-user {
  font-size: 13px;
  color: #999;
  display: inline-block;
  line-height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/service/index.vue